import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./api";

export type ThrottleProfile = "warmup" | "scraping" | "inviting";

export interface ThrottleRow {
  profile: ThrottleProfile;
  min_delay_seconds: number;
  max_delay_seconds: number;
  max_per_account_per_day: number | null;
  is_default: boolean;
}

export const THROTTLE_KEY = ["throttle"] as const;

export function useThrottle() {
  return useQuery<ThrottleRow[]>({
    queryKey: THROTTLE_KEY,
    queryFn: () => api.get<ThrottleRow[]>("/api/throttle"),
  });
}

export function useUpsertThrottle() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      profile,
      ...payload
    }: {
      profile: ThrottleProfile;
      min_delay_seconds: number;
      max_delay_seconds: number;
      max_per_account_per_day?: number | null;
    }) =>
      api.put<ThrottleRow>(`/api/throttle/${profile}`, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: THROTTLE_KEY }),
  });
}

export function useResetThrottle() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (profile: ThrottleProfile) =>
      api.delete<void>(`/api/throttle/${profile}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: THROTTLE_KEY }),
  });
}
